/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLandmine = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M21 18.5c0-1.5-1.5-1.5-1.5-1.5h-15S3 17 3 18.5V20h18zM7 14h10v1.5H7z" /><path fill="currentColor" fillRule="evenodd" d="M11.25 10V4h1.5v6zM15 11.121l4.243-4.242 1.06 1.06-4.242 4.243zM8.243 12.121 4 7.88l1.06-1.061 4.243 4.243z" clipRule="evenodd" /></svg>;
export default SvgLandmine;